//General
import React, { useContext } from "react";
//Styles
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
//Context
import { SuppliersContext } from "../../data/suppliers/SuppliersContext";
import { useValidations } from "../../data/ValidationContext";
import { DealersContext } from "../../data/dealers/DealersContex";

const SuppliersAddModal = ({ isOpen, onClose }) => {
    const { addSupplier } = useContext(SuppliersContext);
    const { dealersList } = useContext(DealersContext);
    const { vs_supplier } = useValidations();
    
const initialValues = { 
supplierName: "", 
dealerName: "", 
status: "Aktif" 
};
    //HTML 

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Formik
                initialValues={initialValues}
                validationSchema={vs_supplier}
                onSubmit={(values) => {
                    addSupplier(values);
                    onClose();
                }}
            >
                {({ values, errors, touched, setFieldValue, handleChange }) => (
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>Tedarikçi Ekle</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            {/* Tedarikçi Adı */}
                            <div className="mb-3">
                                <TextField
                                    label="Tedarikçi Adı"
                                    name="supplierName"
                                    value={values.supplierName}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    error={touched.supplierName && !!errors.supplierName}
                                    helperText={touched.supplierName && errors.supplierName}
                                />
                            </div>

                            {/* Bayi Adı - Autocomplete */}
                            <div className="mb-3">
                                <Autocomplete
                                    options={dealersList.map((d) => d.name)}
                                    value={values.dealerName || null}
                                    onChange={(_, newValue) => setFieldValue("dealerName", newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Bayi Adı"
                                            size="small"
                                            error={touched.dealerName && !!errors.dealerName}
                                            helperText={touched.dealerName && errors.dealerName}
                                        />
                                    )}
                                />
                            </div>

                            {/* Durum */}

                        </Modal.Body>

                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary" onClick={onClose}>
                                İptal
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Kaydet
                            </button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default SuppliersAddModal;
